import { mapV2AuditResponseToV1 } from './v2-to-v1'

/**
 * @typedef {import('../../../api-v2/js-doc').V2AuditResponse} V2AuditResponse
 * @typedef {import('../../../api-v2/js-doc').V1UpdatedByUser} V1UpdatedByUser
 */
export class UserMapper {
  /**
   * @param {V2AuditResponse} v2Response - V2 response what contains createdAt and createdBy fields
   * @returns {V1UpdatedByUser}
   */
  static v2AuditResponseToV1 (v2Response) {
    return mapV2AuditResponseToV1(v2Response)
  }
}
  
